var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body"},[_c('MakeDetailTable',{ref:"MakeDetailTable",attrs:{"price-detail":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }